export enum OnboardingRegisterDataActions {
  PRE_PROPOSAL_PAGE = 'tela_proposta',
  GO_TO_PENDENCIES_PAGE = 'continuar_analise',
  PJ_PENDENCIES_PAGE = 'tela_dados',
  FULL_COMERCIAL_ADDRESS = 'endereco_comercial_completo',
  FULL_SOCIAL_MEDIA = 'redes_sociais_completo',
  EMAIL_VALIDATION = 'validar_email_completo',
  PHONE_VALIDATION = 'validar_celular_completo',
  GO_TO_DOCUMENTATION_PAGE = 'continuar_solicitacao'
}
